import axios from "../axios";
import { setAlert } from "actions/alert";
import { setErrorsList } from "actions/errors";

import {
  CARD_CREATED,
  CARD_ERROR,
  DELETE_CARD,
  CARD_UPDATED,
  GET_CARD_BY_ID,
  CARD_SEARCH_PARAMETERS_UPDATE,
  REMOVE_ERRORS,
  LOADING_ON_CARD_SUBMIT,
  LOADING_CARD_LIST_DATA,
  LOAD_PAGE,
  RESET,
  CARD_LIST_UPDATED,
} from "actions/types";
import { logout } from "actions/auth";
import { CARD } from "constants/api";

export const getCardList = (cardParams) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    dispatch({ type: REMOVE_ERRORS });
    dispatch({ type: LOADING_CARD_LIST_DATA });
    const query = cardParams.query ? cardParams.query : "";
    cardParams.query = query;
    cardParams.page = cardParams.page ? cardParams.page : 1;

    config.params = cardParams;
    const res = await axios.get(CARD.LIST().ENDPOINT, config);

    dispatch({
      type: CARD_SEARCH_PARAMETERS_UPDATE,
      payload: cardParams,
    });
    dispatch({
      type: CARD_LIST_UPDATED,
      payload: res.data.response[0],
    });
    return res.data ? res.data : { status: false };
  } catch (err) {
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: CARD_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

export const getCardById = (card_id) => async (dispatch) => {
  dispatch({ type: REMOVE_ERRORS });
  dispatch(loadingOnCardSubmit());
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.get(CARD.CARD(card_id).ENDPOINT, config);

    await dispatch({
      type: GET_CARD_BY_ID,
      payload: res.data.response,
    });
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: CARD_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

export const create = (formData, history) => async (dispatch) => {
  dispatch({ type: REMOVE_ERRORS });
  dispatch(loadingOnCardSubmit());
  const config = {
    headers: {
      "Content-Type": "application/json; multipart/form-data;",
    },
  };
  try {
    const data = new FormData();
    for (let i in formData) {
      data.append(i, formData[i]);
    }
    const res = await axios.post(CARD.CREATE().ENDPOINT, data, config);
    if (res.data.status === true) {
      dispatch({
        type: CARD_CREATED,
        payload: res.data.response,
      });
      dispatch(setAlert("Card Created.", "success"));
      history("/home/whyWall2floor");
    } else {
      const errors = res.data.errors;
      if (errors) {
        dispatch(setAlert(res.data.message, "danger"));
        errors.forEach((error) => {
          dispatch(setErrorsList(error.msg, error.param));
        });
      }
    }
    return res.data ? res.data : { status: false };
  } catch (err) {
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: CARD_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

export const editCard = (formData, history, card_id) => async (dispatch) => {
  dispatch({ type: REMOVE_ERRORS });
  dispatch(loadingOnCardSubmit());
  const config = {
    headers: {
      "Content-Type": "application/json; multipart/form-data;",
    },
  };
  try {
    const data = new FormData();
    for (let i in formData) {
      data.append(i, formData[i]);
    }
    const res = await axios.post(CARD.EDIT(card_id).ENDPOINT, data, config);
    if (res.data.status === true) {
      dispatch({
        type: CARD_UPDATED,
        payload: res.data.response,
      });
      dispatch(setAlert("Card Updated.", "success"));
      history("/home/whyWall2floor");
    } else {
      const errors = res.data.errors;
      if (errors) {
        dispatch({ type: CARD_ERROR });
        dispatch(setAlert(res.data.message, "danger"));

        errors.forEach((error) => {
          dispatch(setErrorsList(error.msg, error.param));
        });
      }
    }
    return res.data ? res.data : { status: false };
  } catch (err) {
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: CARD_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

export const deleteCard = (card_id, history) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    await axios.delete(CARD.DELETE(card_id).ENDPOINT, config);

    dispatch({ type: DELETE_CARD, payload: card_id });
    dispatch(setAlert("Card deleted.", "success"));
  } catch (err) {
    if (err.response) {
      if (err.response.data && err.response.data.tokenStatus === 0) {
        dispatch(logout());
      } else {
        dispatch({
          type: CARD_ERROR,
          payload: {
            msg: err.response.statusText,
            status: err.response.status,
          },
        });
        dispatch(
          setAlert(
            err.response.data.message || err.response.statusText,
            "danger"
          )
        );
      }
    }
  }
};

// Delete User
export const cancelSave = (history) => async (dispatch) => {
  // dispatch({ type: REMOVE_ALERT });
  dispatch({ type: REMOVE_ERRORS });
  history("/home/whyWall2floor");
};

// Dispatch Loading
export const loadingOnCardSubmit = () => async (dispatch) => {
  await dispatch({ type: LOADING_ON_CARD_SUBMIT });
};

// page not found
export const notFound = (history) => async (dispatch) => {
  history("/home/page-not-found");
};

export const setErrors = (errors) => async (dispatch) => {
  if (errors) {
    dispatch({ type: CARD_ERROR });
    dispatch(setAlert("Please correct the following errors", "danger"));
    errors.forEach((error) => {
      dispatch(setErrorsList(error.msg, error.param));
    });
  }
};

// Load Page/Show Page
export const loadPage = () => async (dispatch) => {
  await dispatch({ type: LOAD_PAGE });
};

// reset errors
export const removeErrors = () => async (dispatch) => {
  dispatch({ type: REMOVE_ERRORS });
};

// Dispatch Reset store
export const resetComponentStore = () => async (dispatch) => {
  await dispatch({ type: RESET });
};
